import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { getData } from 'src/services/RestApi';
import SearchSelectField from 'src/components/widgets/search-select-field';
import { setCacheLocations, getCacheLocations } from 'src/utils/cache-data';

export const DropdownLocations = ({
  formik,
  hintValue = '',
  disabled = false,
}) => {
  const [data, setData] = useState([]);
  const isFetchingData = useRef(false); // Ref to track if the API call is in progress

  const bindToView = (result) => {
    if (Array.isArray(result)) {
      setData(result); // Store data in state
    }
  };

  // Memoize the API call function to avoid calls many more
  const fetchData = useCallback(async () => {
    if (!isFetchingData.current) {
      isFetchingData.current = true; // Set the flag to avoid API calls
      const { result } = await getData('api/location/list/cache');
      if (result) {
        bindToView(result);
        setCacheLocations(result);
      }
      isFetchingData.current = false; // Reset the flag after fetching
    }
  }, [data]);

  useEffect(() => {
    const savedData = getCacheLocations();
    if (savedData) {
      bindToView(savedData);
    } else {
      fetchData(); // Fetch data on component mount
    }
  }, []);

  const handleChanged = (selectedOption) => {
    formik.setFieldValue('locationField', selectedOption);
  };

  return (
    <SearchSelectField
      label="Địa điểm"
      name="locationField"
      disabled={disabled}
      options={data}
      onSelected={handleChanged}
      formik={formik}
      hintValue={hintValue} // '<name>'
    />
  );
};

DropdownLocations.propTypes = {
  formik: PropTypes.object.isRequired,
};

export default DropdownLocations;
